/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck1">
<label class="accordion-label" for="chck1">How to make repayment?</label>
<div class="accordion-content">
<p>
Repayments can be made through ATM, internet banking and mobile banking. You can also use the Virtual Account (VA) payment code through Bank BCA, Bank BRI, Bank BNI and Bank Mandiri. For payments through E-Wallet, you can use ShopeePay and OVO. Use Alfamart payment code if you want to make payment in cash.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">The validity period of the VA (Virtual Account)</label>
<div class="accordion-content">
<p>
The VA can be checked on the Easycash app, make sure that your VA is in accordance with the app.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Information on late fees</label>
<div class="accordion-content">
<p>
The daily late penalty is {2} + your daily interest. For late fee information, you can see details on the Easycash app.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">What happens if I don't repay on-time?</label>
<div class="accordion-content">
<p>
Ensure your payment can be made by the latest due date stated on the Easycash app. If there is a delay, you will be regularly contacted by our collection team. The late fee will be given according to the policies applied on the app.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">Can I make early repayment of the loan?</label>
<div class="accordion-content">
<p>
You can make early repayment but there are no fees or interest discounts.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Request for extension of Easycash loan tenure</label>
<div class="accordion-content">
<p>
There is currently no extension of the tenure period. If the payment is made past the time limit stated on the app, a late penalty will be imposed.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Pending repayment issues</label>
<div class="accordion-content">
<p>
Regarding your payment, please be willing to wait 1 x 24 hours. If within that time there have been no changes to the Easycash app, please contact Easycash Customer Service by attaching proof of payment via email: <a href="mailto: cs.pinjaman@easycash.id">cs.pinjaman@easycash.id</a>, live chat on the Easycash app, or contact the Call Center <a href="tel:1500866">1500866</a>.
</p>
</div>
</div>

</div>

</div>

`;

export default faq;
